import { GAME_ID, ALEX_STATES } from '../../data/constants';

const initialState = { alexState: 0 };

const alexReducer = (state = initialState, { gameId, type }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case 'SET_ALEX_INACTIVE':
      return {
        ...state,
        alexState: ALEX_STATES.inactive,
      };

    case 'SET_ALEX_ACTIVE':
      return {
        ...state,
        alexState: ALEX_STATES.active,
      };

    case 'SET_ALEX_SPEAKING':
      return {
        ...state,
        alexState: ALEX_STATES.speaking,
      };

    default:
      return state;
  }
};

export default alexReducer;
